import React from "react";
import ScrollToTop from "react-scroll-to-top";
import GlobalStyles from "styles/GlobalStyles";
import Home from "pages/Home";
import Business from "pages/Business";
import AboutUs from "pages/AboutUs";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Services from "pages/Services";
import Reinforcement from "pages/Reinforcement";
import Recruitment from "pages/Recruitment";
import Salary from "pages/Salary";
import Contact from "pages/Contact";
import Employee from "pages/Employee";
import NotFound from "pages/NotFound";
import PrivacyPolicyPage from "pages/PrivacyPage";
import Announcement from "pages/Announcement";
import { SHOW_SALARY_ESTIMATOR } from "config/featureFlags";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/it-service" element={<Services />} />
          <Route path="/business" element={<Business />} />
          <Route path="/business-reinforcement" element={<Reinforcement />} />
          <Route path="/company" element={<AboutUs />} />
          <Route path="/recruitment" element={<Recruitment />} />
          {SHOW_SALARY_ESTIMATOR && (
            <Route path="/recruitment/salary" element={<Salary />} />
          )}
          <Route path="/contact" element={<Contact />} />
          <Route path="/employee" element={<Employee />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/announcement/website-renewal"
            element={<Announcement />}
          />
          <Route
            path="/announcement/notice-fraud-alert"
            element={<Announcement />}
          />
          <Route
            path="/announcement/fraudulent-emails-impersonating-our-company"
            element={<Announcement />}
          />
          <Route
            path="/announcement/systemsoft-group-participation"
            element={<Announcement />}
          />
          <Route
            path="/announcement/head-office-relocation"
            element={<Announcement />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <ScrollToTop smooth />
    </>
  );
}
